import gql from 'graphql-tag';

import COULD_NOT_COMPLETE_FRAGMENT from '../serviceDocket/COULD_NOT_COMPLETE_FRAGMENT';

// Note: vendout predictions are no currently used in service run status (October 2019), but are used in multi-select, so must get them here

const STATUS_DOCKETS_FRAGMENT = gql`
	fragment statusDockets on ServiceDocket {
		id
		status
		date
		lastService
		inventoryCheck
		replacementReviewRequired
		replacementReviewReason
		manualRestock
		isIngredientRestock
		marketRestockCorrectionAvailability {
			allowed
			reason
		}
		manualRestockComment
		manualRestockApprovedBy {
			id
			firstname
			lastname
		}
		isRestocked
		startedProcessing
		ticketsResolved
		someTicketsNotResolved
		inventoryPicked
		inventoryPartiallyPicked
		pickListGenerationStatus
		machineServiceType
		machineRestockType
		collectCash
		cashCollected
		cashBag
		requirePhoto
		photoTaken
		permanentPackTags {
			id
			name
			abbreviation
		}
		packTags {
			id
			name
			abbreviation
		}
		freshBoxManufacturers {
			id
			name
		}
		pickList {
			id
			calculatedAt
			isAnyItemPicked
			pickers {
				id
				firstname
				lastname
				username
				destroyed
			}
		}
		driverTicketCount

		salesMeter
		salesSinceLastRestock
		vendsSinceLastRestock
		coinsSinceLastRestock
		notesSinceLastRestock
		cardSinceLastRestock
		notesCollected
		coinsCollected
		collectedVariance

		coinsSinceLastCollection
		notesSinceLastCollection
		cashSinceLastCollection

		inventoryChanges
		inventoryChangesPercentage
		inventoryChangesSelections
		order
		totalPickItemsQuantity
		tub
		tubWeightSummary
		place {
			id
			name
			destroyed
		}
		location {
			id
			name
			destroyed
			client {
				id
				name
			}
		}
		serviceRun {
			id
			warehouse {
				id
			}
			returnWarehouse {
				id
			}
		}
		machine {
			id
			assetId
			brand
			type
			place {
				id
				name
				destroyed
				serviceGroup {
					id
					name
					location {
						id
						name
					}
				}
			}
			
			vendsSinceLastRestock
			salesSinceLastRestock
			coinsSinceLastRestock
			notesSinceLastRestock
			cardSinceLastRestock

			coinsSinceLastCollection
			notesSinceLastCollection
			cashSinceLastCollection
			
			lastCommunication
			lastService
			vendouts
			vendoutPredictionTomorrow
			percentageFull
			daysSinceLastService
			salesLast7Days
			planogram {
				id
			}
			freshFoodManufacturers {
				id
				name
			}
			ingredientPlanogram {
				id
			}
			isOffline
			usesIngredients
			location {
				id
				name
				destroyed
				client {
					id
					name
				}
			}
			destroyed
			openTicketCount
			openIssueTicketCount
			openMaintenanceTicketCount
			openJobTicketCount
			noteCount
			coordinates
			planogramItemNextExpiryDate
			requiredSitePermissions {
				id
				name
				durationInDays
				daysOfWeek
				policy
				clients {
					id
				}
				locations {
					id
				}
				places {
					id
				}
				legacyMachines {
					id
				}
			}
			siteBookingNotices {
				id
				name
				bookingProcess
				clients {
					id
				}
				locations {
					id
				}
				places {
					id
				}
			}
		}
		dune
		expiryProductsCount
		...stopCouldNotComplete
	}
	${COULD_NOT_COMPLETE_FRAGMENT}
`;

export default STATUS_DOCKETS_FRAGMENT;
